import React from 'react'
import styles from './HeatLayerToggle.scss'
import { SIGNUP_MODAL } from 'common/modals/SignupModal'
import { CAROUSEL_MODAL } from 'features/recumbent/UpgradeModal/CarouselModal'
import { PAYMENT_FORM_MODAL } from 'features/payments/PaymentForm'
import { useFormatMessage, featureNames } from 'lib/localization'
import { showModal } from 'lib/modalUtils'
import { defineMessages } from 'react-intl'
import cx from 'classnames'

export const HEATMAP_OVERLAY_PREF = 'heatmap_overlay'

const messages = defineMessages({
  viewPublicHeat: {
    id: 'HeatLayerToggle.viewPublicHeat',
    defaultMessage: 'View Public Heatmap'
  }
})

export const HeatLayerToggle = ({ heatLayer, toggle, enabled }) => {
  const fm = useFormatMessage()

  const onClick = e => {
    e.preventDefault()

    if (!enabled) {
      showModal(CAROUSEL_MODAL, {
        feature: 'heatmap',
        helpPathMessage: messages.viewPublicHeat,
        onCreateAccount: () => showModal(SIGNUP_MODAL, { onRequestLogin: () => window.rwgps.loginModalOverlay() }),
        onUpgrade: () => showModal(PAYMENT_FORM_MODAL, { reloadUser: () => window.location.reload() })
      })
      return
    }

    toggle()
  }

  return (
    <div className={styles.heatContainer}>
      <button onClick={onClick} className={cx(styles.HeatLayerToggle, heatLayer && styles.active, !enabled && styles.disabled)}>
        {fm(featureNames.heatmap)}
      </button>
    </div>
  )
}
